import { Route } from 'react-router-dom';

import { DossierPage } from './Dossier';

export const DossierRoute = () => {
    return <Route path="/dossier/:dossierId" component={DossierPage} />;
};
